const docTypes = [
    'doc',
    'list'
]

export default docTypes